import type { Winner } from '@src/@types/ozonPrizeWinners';

const AMOUNT_20000 = '20 000 ₽';
const AMOUNT_10000 = '10 000 ₽';

export const WINNER_20000_LIST: Winner[] = [
  { id: 7, phoneNumber: '+79056180411', amount: AMOUNT_20000 },
  { id: 8, phoneNumber: '+79202220941', amount: AMOUNT_20000 },
  { id: 9, phoneNumber: '+79094430973', amount: AMOUNT_20000 },
  { id: 10, phoneNumber: '+79537091444', amount: AMOUNT_20000 },
  { id: 11, phoneNumber: '+79516874688', amount: AMOUNT_20000 },
  { id: 12, phoneNumber: '+79234667077', amount: AMOUNT_20000 },
  { id: 13, phoneNumber: '+79851727549', amount: AMOUNT_20000 },
  { id: 14, phoneNumber: '+79144618459', amount: AMOUNT_20000 },
  { id: 15, phoneNumber: '+79966058621', amount: AMOUNT_20000 },
  { id: 16, phoneNumber: '+79610638835', amount: AMOUNT_20000 },
];

export const WINNER_10000_LIST: Winner[] = [
  { id: 17, phoneNumber: '+79306880074', amount: AMOUNT_10000 },
  { id: 18, phoneNumber: '+79626570179', amount: AMOUNT_10000 },
  { id: 19, phoneNumber: '+79618860203', amount: AMOUNT_10000 },
  { id: 20, phoneNumber: '+79610010416', amount: AMOUNT_10000 },
  { id: 21, phoneNumber: '+79501150625', amount: AMOUNT_10000 },
  { id: 22, phoneNumber: '+79135741129', amount: AMOUNT_10000 },
  { id: 23, phoneNumber: '+79533511294', amount: AMOUNT_10000 },
  { id: 24, phoneNumber: '+79229181523', amount: AMOUNT_10000 },
  { id: 25, phoneNumber: '+79899971549', amount: AMOUNT_10000 },
  { id: 26, phoneNumber: '+79533441578', amount: AMOUNT_10000 },
  { id: 27, phoneNumber: '+79779911678', amount: AMOUNT_10000 },
  { id: 28, phoneNumber: '+79236811741', amount: AMOUNT_10000 },
  { id: 29, phoneNumber: '+79803791858', amount: AMOUNT_10000 },
  { id: 30, phoneNumber: '+79132381897', amount: AMOUNT_10000 },
  { id: 31, phoneNumber: '+79044181923', amount: AMOUNT_10000 },
  { id: 32, phoneNumber: '+79259061936', amount: AMOUNT_10000 },
  { id: 33, phoneNumber: '+79101862854', amount: AMOUNT_10000 },
  { id: 34, phoneNumber: '+79873833002', amount: AMOUNT_10000 },
  { id: 35, phoneNumber: '+79511703012', amount: AMOUNT_10000 },
  { id: 36, phoneNumber: '+79278533362', amount: AMOUNT_10000 },
  { id: 37, phoneNumber: '+79518663548', amount: AMOUNT_10000 },
  { id: 38, phoneNumber: '+79995823581', amount: AMOUNT_10000 },
  { id: 39, phoneNumber: '+79020093797', amount: AMOUNT_10000 },
  { id: 40, phoneNumber: '+79806503880', amount: AMOUNT_10000 },
  { id: 41, phoneNumber: '+79278853896', amount: AMOUNT_10000 },
  { id: 42, phoneNumber: '+79234754625', amount: AMOUNT_10000 },
  { id: 43, phoneNumber: '+79969164971', amount: AMOUNT_10000 },
  { id: 44, phoneNumber: '+79183585004', amount: AMOUNT_10000 },
  { id: 45, phoneNumber: '+79279505153', amount: AMOUNT_10000 },
  { id: 46, phoneNumber: '+79210165403', amount: AMOUNT_10000 },
  { id: 47, phoneNumber: '+79147396528', amount: AMOUNT_10000 },
  { id: 48, phoneNumber: '+79093396777', amount: AMOUNT_10000 },
  { id: 49, phoneNumber: '+79532616948', amount: AMOUNT_10000 },
  { id: 50, phoneNumber: '+79124367344', amount: AMOUNT_10000 },
  { id: 51, phoneNumber: '+79629377572', amount: AMOUNT_10000 },
  { id: 52, phoneNumber: '+79173887699', amount: AMOUNT_10000 },
  { id: 53, phoneNumber: '+79632577890', amount: AMOUNT_10000 },
  { id: 54, phoneNumber: '+79260578089', amount: AMOUNT_10000 },
  { id: 55, phoneNumber: '+79173678304', amount: AMOUNT_10000 },
  { id: 56, phoneNumber: '+79169738582', amount: AMOUNT_10000 },
  { id: 57, phoneNumber: '+79913398760', amount: AMOUNT_10000 },
  { id: 58, phoneNumber: '+79061639002', amount: AMOUNT_10000 },
  { id: 59, phoneNumber: '+79933279538', amount: AMOUNT_10000 },
  { id: 60, phoneNumber: '+79083219696', amount: AMOUNT_10000 },
  { id: 61, phoneNumber: '+79650759944', amount: AMOUNT_10000 },
];
